// extracted by css-extract-rspack-plugin
export default {"tableLayoutFixed":"DiffLines-module__tableLayoutFixed___t2BXe2","compact":"DiffLines-module__compact__cjJjaCu"};